import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useAddNote } from '../../hooks/useContacts.js';
import { Modal } from '../ui/Modal.js';
import { Button } from '../ui/Button.js';
import { Textarea } from '../ui/Textarea.js';
import { useToast } from '../ui/Toast.js';

interface Props {
  contactId: number;
  isOpen: boolean;
  onClose: () => void;
}

export function AddNoteModal({ contactId, isOpen, onClose }: Props) {
  const { t } = useTranslation();
  const toast  = useToast();
  const [text, setText] = useState('');
  const addNote = useAddNote();

  const handleSave = async () => {
    if (!text.trim()) return;
    try {
      await addNote.mutateAsync({ contactId, text });
      toast.success(t('contacts.notes.toast_saved'));
      setText('');
      onClose();
    } catch {
      toast.error(t('contacts.notes.toast_error'));
    }
  };

  return (
    <Modal
      open={isOpen}
      onClose={onClose}
      title={t('contacts.notes.modal_title')}
      size="sm"
      footer={
        <>
          <Button variant="outline" tone="muted" size="sm" onClick={onClose}>
            {t('contacts.notes.cancel')}
          </Button>
          <Button
            variant="solid"
            tone="cyan"
            size="sm"
            disabled={!text.trim() || addNote.isPending}
            loading={addNote.isPending}
            onClick={() => void handleSave()}
          >
            {t('contacts.notes.save')}
          </Button>
        </>
      }
    >
      <Textarea
        value={text}
        onChange={setText}
        placeholder={t('contacts.notes.placeholder')}
        rows={6}
        fullWidth
      />
    </Modal>
  );
}
